import { render, staticRenderFns } from "./ApplicationsOverviewCoaching.vue?vue&type=template&id=0cbceede&scoped=true"
import script from "./ApplicationsOverviewCoaching.vue?vue&type=script&lang=js"
export * from "./ApplicationsOverviewCoaching.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsOverviewCoaching.vue?vue&type=style&index=0&id=0cbceede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbceede",
  null
  
)

export default component.exports